module.exports = __webpack_public_path__ + "img/acReport.7e3969f1.svg";